import { useTranslation } from "react-i18next";
import styles from "./HATVLeaderDetails.module.scss";
import { useEffect, useMemo, useState } from "react";
import PerformanceTable, {
  PerformanceTableData,
} from "../PerformanceTable/PerformanceTable";
import HATVKPITable from "../HATVKPITable/HATVKPITable";
import {
  useProfileParams,
  getSlashSeparatedFormattedDate,
} from "../../../utils/common";
import {
  useLazyGetHATVAboStatisticQuery,
  useLazyGetUserNameWithIDQuery,
} from "../../../redux/services/hatvAboStatisticAPI";
import { NumberFormatter } from "../../../utils/NumberFormatter";
import { useAppSelector } from "../../../redux/hooks";
import SuccessionDocLoader from "../../common/Loaders/SuccessionDocLoader/SuccessionDocLoader";

interface HATVLeaderDetailsProps {
  selectedYearMonth: string;
}
const HATVLeaderDetails: React.FC<HATVLeaderDetailsProps> = ({
  selectedYearMonth,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("hatv_kpis");
  const [ABOStatisticsdata, setABOStatisticsData] = useState<any>(null);
  const { affiliateCode, aboNumber } = useProfileParams();
  const [userNameById, setUserNameById] = useState<string>("");
  const userDetails = useAppSelector((state: any) => state.userDetails.user);
  const [userAffiliateCode] = useState(userDetails?.userAffiliateCode || 0);
  const [
    getHATVStatisticsLeaderDeatailsResponseData,
    {
      isLoading: isLoadingGetAboStatisticsAPI,
      isError,
      isSuccess: isGetAboStatisticstSuccess,
    },
  ] = useLazyGetHATVAboStatisticQuery();

  const [
    getUserNameFromId,
    { isLoading: isGetUserNameLoading, isError: isGetUserNameError },
  ] = useLazyGetUserNameWithIDQuery();

  useEffect(() => {
    if ( aboNumber && selectedYearMonth && affiliateCode ) {
      getHATVStatisticsLeaderDeatailsResponseData({
        closingMonth: selectedYearMonth,
        affiliateCode,
        aboNumber,
      })
        .then((resp) => {
          setABOStatisticsData(resp?.data?.body?.leaderStatisticSummary);
          const userIdAvailable =
            resp?.data?.body?.leaderStatisticSummary?.hatvAdmin?.userNativeId;
          if (userIdAvailable) {
            getUserNameFromId({
              nativeId: userIdAvailable,
            }).then((userDetailsResp: any) => {
              setUserNameById(userDetailsResp?.data?.body?.fullName);
            });
          }
        })
        .catch((err) => {
          setABOStatisticsData(null);
        });
    }
  }, [selectedYearMonth, affiliateCode, aboNumber]);
  
  const displayValue = (inputValue: number | string | null | undefined, outputValue?: number | string): number | string => {
    if(inputValue === 0) return 0;
    if(!inputValue) return "-";
    
    return outputValue ?? inputValue;
  }

  return (
    <section
      className={`hatv_leader_container ${styles.hatv_leader_container}`}
    >
      <div className={styles.title_wrapper}>
        <div className={styles.title}>{t("hatv_leader_details.title")}</div>
      </div>
      {isLoadingGetAboStatisticsAPI ? (
        <SuccessionDocLoader num={0} heading={""} />
      ) : (
        <div className={`details_wrapper ${styles.details_wrapper}`}>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.q_months")}:{" "}
            {displayValue(ABOStatisticsdata?.qMonth)}
          </div>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.q_legs")}:{" "}
            {displayValue(ABOStatisticsdata?.qLeg)}
          </div>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.annual_gpv")}:{" "}
            {displayValue(ABOStatisticsdata?.annualGroupPv, NumberFormatter(
                userAffiliateCode,
                ABOStatisticsdata?.annualGroupPv
            ))}
          </div>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.ve_pv")}:{" "}
            {displayValue(ABOStatisticsdata?.vePv, NumberFormatter(
                userAffiliateCode,
                ABOStatisticsdata?.vePv
            ))}
          </div>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.entry_date")}:{" "}
            {ABOStatisticsdata
              ? getSlashSeparatedFormattedDate(ABOStatisticsdata?.entryDate)
              : "-"}
          </div>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.upline_platinum")}:{" "}
            {ABOStatisticsdata?.uplinePlatinum?.accountName
              ? ABOStatisticsdata?.uplinePlatinum?.accountName
              : "-"}
          </div>
          <div className={`detail ${styles.detail}`}>
            {t("hatv_leader_details.case_evaluator")}:{" "}
            {userNameById ? userNameById : "-"}
          </div>
        </div>
      )}
      <div>
        <div className={`tab_wrapper ${styles.tab_wrapper}`}>
          <div className={`tabs ${styles.tabs}`}>
            <div
              className={`tab ${styles.tab} ${activeTab === "hatv_kpis" ? styles.active : ""}`}
              onClick={() => setActiveTab("hatv_kpis")}
            >
              {t("hatv_kpis")}
            </div>
            <div
              className={`${styles.tab} ${activeTab === "leader_performance" ? styles.active : ""}`}
              onClick={() => setActiveTab("leader_performance")}
            >
              {t("leader_performance")}
            </div>
          </div>
        </div>
        <div className={`tab_content ${styles.tab_content}`}>
          {activeTab === "hatv_kpis" ? (
            <div>
              <HATVKPITable selectedYearMonth={selectedYearMonth} />
            </div>
          ) : (
            <PerformanceTable
              closingMonth={selectedYearMonth}
              affiliateCode={affiliateCode}
              aboNumber={aboNumber}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default HATVLeaderDetails;
